import {
  REPORTING_TAB_TYPES,
  REPORTING_VIEW_TYPES,
} from "@/pages/reporting_v2/types";

import type { GetCustomersResponse } from "server/dwhApi/customers/models.js";
import type { Customer } from "server/dwhApi/customers/types.js";
import type {
  GetTerminalAggregatesPeriodsResponse,
  GetTerminalPeriodsResponse,
} from "server/dwhApi/terminals/models.js";
import {
  type Terminal,
  type TerminalAggregate,
  TerminalAggregatesPeriod,
  TerminalPeriod,
} from "server/dwhApi/terminals/types.js";

export const toPortfolioPeriods = (periods: TerminalAggregatesPeriod[]) =>
  periods.map((p) => ({
    startTime: p.startTime,
    endTime: p.endTime,
    source: p.terminalAggregates,
  }));

export const toBuildingPeriods = (periods: TerminalPeriod[]) =>
  periods.map((p) => ({
    startTime: p.startTime,
    endTime: p.endTime,
    source: p.terminal,
  }));

export type ActiveReportingData = {
  periods?: {
    startTime: string;
    endTime: string;
    source: TerminalAggregate | Terminal;
  }[];
  terminals?: Terminal[];
  customers?: Customer[];
};

export const getReportingActiveData = ({
  viewType,
  tabType,
  aggregatesData,
  terminalsData,
  periodData,
  customersData,
  selectedBuildingIds,
}: {
  viewType: REPORTING_VIEW_TYPES;
  tabType: REPORTING_TAB_TYPES;
  aggregatesData?: GetTerminalAggregatesPeriodsResponse;
  terminalsData?: Terminal[];
  periodData?: GetTerminalPeriodsResponse;
  customersData?: GetCustomersResponse;
  selectedBuildingIds: string[] | null;
}): ActiveReportingData => {
  const isPortfolioView = viewType === REPORTING_VIEW_TYPES.PORTFOLIO;
  const isIndividualTab = tabType === REPORTING_TAB_TYPES.INDIVIDUAL;

  if (isPortfolioView && !isIndividualTab) {
    return {
      periods: toPortfolioPeriods(aggregatesData?.periods ?? []),
    };
  }
  if (isPortfolioView) {
    const terminals = (terminalsData ?? []).filter(
      (terminal) =>
        !selectedBuildingIds ||
        selectedBuildingIds.includes(terminal.terminalId),
    );
    return { terminals };
  }
  if (!isIndividualTab) {
    return { periods: toBuildingPeriods(periodData?.periods ?? []) };
  }
  return { customers: customersData?.customers ?? [] };
};
